<template>
  <v-data-table :headers="headers" :items="items" dense hide-default-footer disable-pagination>
    <template v-slot:item.no="{ index }">
      {{ index + 1 }}
    </template>
    <template v-slot:item.priceOriginalPrice="{ item }">
      {{ formatPrice(item.priceOriginalPrice) }}
    </template>
    <template v-slot:item.priceIdr="{ item }">
      {{ formatPrice(item.priceIdr) }}
    </template>
    <template v-slot:item.total="{ item }">
      {{ formatPrice(item.priceIdr * item.qty) }}
    </template>
    <template v-slot:body.append="{ items }">
      <tr>
        <td colspan="10" class="text-right">TOTAL IDR</td>
        <td class="rext-right">{{ formatPrice(totalPriceIdr(items)) }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "detail-bom-list",
  props: {
    items: Array,
  },
  data() {
    return {
      headers: [
        {
          id: 1,
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 1,
          text: "Part#",
          align: "left",
          sortable: false,
          value: "partNum",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 1,
          text: "Part Name",
          align: "left",
          sortable: false,
          value: "partName",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 1,
          text: "Description",
          align: "left",
          sortable: false,
          value: "partDesc",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 1,
          text: "MFR",
          align: "center",
          sortable: false,
          value: "mfr",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 1,
          text: "UM",
          align: "center",
          sortable: false,
          value: "um",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 1,
          text: "Qty",
          align: "center",
          sortable: false,
          value: "qty",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 1,
          text: "Curr",
          align: "center",
          sortable: false,
          value: "priceOriginalCurrency",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 1,
          text: "Price",
          align: "right",
          sortable: false,
          value: "priceOriginalPrice",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 1,
          text: "Price IDR",
          align: "right",
          sortable: false,
          value: "priceIdr",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 1,
          text: "Total",
          align: "right",
          sortable: false,
          value: "total",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    totalPriceIdr(items) {
      if (items && items.length > 0) {
        return items.map(x => x.priceIdr * x.qty).reduce((x, y) => x + y);
      }
      return 0;
    },
  },
};
</script>

<style></style>
